import React from "react";

import { useIntl } from "react-intl";

import {
    AtlassianNavigation,
    PrimaryButton,
    ProductHome
} from "@atlaskit/atlassian-navigation";
import { AtlassianIcon, AtlassianLogo } from "@atlaskit/logo";

import { messages } from "./messages";
import { NavigationProfile } from "./navigation-profile";

const AtlassianProductHome = (siteTitle: string) => (
    <ProductHome
        icon={AtlassianIcon}
        logo={AtlassianLogo}
        siteTitle={siteTitle}
        href="/fastshift/dashboard"
    />
);

export const FastshiftNavigation: React.FC = () => {
    const { formatMessage } = useIntl();

    return (
        <AtlassianNavigation
            label="site"
            primaryItems={[
                <PrimaryButton key="your-work" selected>
                    {formatMessage(messages.dashboardButtonLabel)}
                </PrimaryButton>
            ]}
            renderProductHome={() =>
                AtlassianProductHome(
                    formatMessage(messages.fastshiftProductHomeTitle)
                )
            }
            renderProfile={NavigationProfile}
        />
    );
};
